import React from 'react';
import {
  StyleSheet, Text, View,
} from 'react-native';
import Colors from '../../constants/Colors';
import DownArrow24 from '../24pxIcons/DownArrow24';
import MonitorIcon from '../MonitorIcon';
import { logEvent } from '../LogEvent';
import PressableStyled from '../PressableStyled';

export default function UserGroupCardMobile({
  group,
  title,
  description,
  setSelectedUserGroup,
}: {
  group: any;
  title: string;
  description: string;
  // eslint-disable-next-line no-unused-vars
  setSelectedUserGroup: (userGroup: any) => void;
}) {
  return (
    <PressableStyled
      onPress={() => {
        setSelectedUserGroup(group);
        logEvent('UserGroupCard', 'drawer_toggle');
      }}
      testID='um-expand-members-user-group-btn'
      style={[styles.groupCard, { marginHorizontal: 24 }]}>
      <View style={{ flexDirection: 'row', alignItems: 'center' }}>
        <View
          style={{
            backgroundColor: Colors.light.hereworksDarkBlue,
            width: 48,
            height: 48,
            borderRadius: 24,
            marginLeft: 20,
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <MonitorIcon color={'#fff'} />
        </View>
        <View style={{ flex: 1, marginVertical: 17, marginRight: 42 }}>
          <Text style={styles.groupName} selectable>{title}</Text>
          <Text style={styles.groupDescription}>{description}</Text>
        </View>
        <View
          style={{ position: 'absolute', right: 20 }}
        >
          <DownArrow24
            style={[{ transform: [{ rotateZ: '270deg' }] }]}
          />
        </View>
      </View>
    </PressableStyled>
  );
}

const styles = StyleSheet.create({
  groupCard: {
    backgroundColor: '#fff',
    alignSelf: 'stretch',
    marginVertical: 4,
    borderRadius: 16,
    borderWidth: 1,
    borderColor: Colors.light.hereworksWhite300,
  },
  groupName: {
    fontSize: 18,
    fontFamily: 'Poppins_600SemiBold',
    marginLeft: 12,
    flex: 1,
  },
  title: {
    fontSize: 18,
    fontFamily: 'Poppins_500Medium>',
    marginLeft: 24,
    color: Colors.light.hereworksBlack500,
  },
  userPic: {
    width: 40,
    height: 40,
    borderRadius: 20,
    overflow: 'hidden',
  },
  headerText: {
    fontFamily: 'Roboto_500Medium',
    fontSize: 10,
    lineHeight: 15,
    letterSpacing: 0.7,
    color: Colors.light.hereworksBlack400,
  },
  groupDescription: {
    fontFamily: 'Roboto_400Regular',
    fontSize: 14,
    lineHeight: 22,
    color: Colors.light.hereworksBlack400,
    marginLeft: 12,
    flex: 1,
  },
  mobileTab: {
    fontFamily: 'Poppins_500Medium',
    fontSize: 14,
    lineHeight: 20,
    color: Colors.light.hereworksBlack500,
  },
});
